import classNames from 'classnames'
import { useSiteInfo } from 'shared'

import { MouseEvent } from 'react'

import { useTranslation } from 'next-i18next'
import SvgIconArrowDown from 'ui/svg/icons/fill/arrow-down.svg'
import SvgSearchIcon from 'ui/svg/icons/stroke/search.svg'
import SvgHamburgerIcon from 'ui/svg/icons/fill/hamburger.svg'
import { AButton } from '../atoms/a-button'
import { ASvg } from '../atoms/a-svg'
import { CustomLink } from './c-the-header'

type Props = {
  theme?: string
  isClear?: boolean
  isClearDark?: boolean
  doctorsUrl?: string
  quizUrl?: string
  discoveryUrl?: string
  openMenu?: () => void
  handleNavigationLinkClick?: (event: MouseEvent<HTMLAnchorElement>) => void
}

export const CTheNavList = (props: Props) => {
  const {
    doctorsUrl,
    discoveryUrl,
    quizUrl,
    isClear,
    theme,
    isClearDark,
    openMenu,
    handleNavigationLinkClick,
  } = props
  const siteInfo = useSiteInfo()
  const { t } = useTranslation('common')

  const shouldHideAuNavItems =
    siteInfo.iso === 'en-AU' ||
    ['southEastAsia', 'australia', 'newZealand'].includes(siteInfo.handle ?? '')

  const handleQuizButtonClick = () => {
    //
  }

  const handleDoctorsButtonClick = () => {
    //
  }

  return (
    <ul
      className={`flex items-center w-[100%] md:w-auto ${
        doctorsUrl ? 'justify-between' : 'justify-end'
      } md:justify-start`}
    >
      {!siteInfo.isES && (
        <>
          {!shouldHideAuNavItems && t('paths.lens') && (
            <li className="c-the-header__nav-item hidden pis-8 xl:block">
              <CustomLink
                className={classNames(
                  'font-bold text-center uppercase transition-all duration-300 text-button align-middle text-neutral-white hover:text-neutral-light-gray',
                  {
                    'text-neutral-white hover:text-neutral-light-gray':
                      (isClear && !isClearDark) ||
                      (!isClear && theme === 'dark'),
                    'text-neutral-white hover:text-neutral-light-gray md:text-neutral-dark-gray md:hover:text-neutral-black':
                      isClear && isClearDark,
                    'text-neutral-dark-gray hover:text-neutral-black':
                      !isClear && theme === 'light',
                  }
                )}
                href={`${discoveryUrl}${t('paths.lens')}`}
                onClick={handleNavigationLinkClick}
              >
                <span>{t('titles.the-lens')}</span>
              </CustomLink>
            </li>
          )}

          {!shouldHideAuNavItems &&
            (t('paths.nightvision') ||
              t('paths.dry-eye') ||
              t('paths.harmony')) && (
              <li className="c-the-header__nav-item hidden pis-8 xl:block">
                <button
                  className={classNames(
                    'inline-flex items-center justify-center font-bold text-center uppercase text-button align-middle text-neutral-white hover:text-neutral-light-gray',
                    {
                      'text-neutral-white hover:text-neutral-light-gray':
                        (isClear && !isClearDark) ||
                        (!isClear && theme === 'dark'),
                      'text-neutral-white hover:text-neutral-light-gray md:text-neutral-dark-gray md:hover:text-neutral-black':
                        isClear && isClearDark,
                      'text-neutral-dark-gray hover:text-neutral-black':
                        !isClear && theme === 'light',
                    }
                  )}
                >
                  <span>{t('benefits')}</span>
                  <ASvg
                    className="fill-current"
                    svg={SvgIconArrowDown}
                    ariaHidden="true"
                  />
                </button>
                <div className="relative -mx-16">
                  <ul className="c-the-header__nav-dropdown absolute top-0 left-0 z-30 w-full transition-all duration-300 m-dropdown text-neutral-dark-gray">
                    {!siteInfo.isIN && (
                      <li className="bg-neutral-light-gray">
                        <CustomLink
                          className="block p-4 font-semibold transition-colors duration-300 text-p hover:text-neutral-black"
                          href={`${discoveryUrl}${t('paths.nightvision')}`}
                          onClick={handleNavigationLinkClick}
                        >
                          {t('titles.night-vision')}
                        </CustomLink>
                      </li>
                    )}
                    <li className="bg-neutral-light-gray border-neutral-gray border-t">
                      <CustomLink
                        className="block p-4 font-semibold transition-colors duration-300 text-p hover:text-neutral-black"
                        href={`${discoveryUrl}${t('paths.dry-eye')}`}
                        onClick={handleNavigationLinkClick}
                      >
                        {t('titles.no-dry-eye')}
                      </CustomLink>
                    </li>
                    <li className="bg-neutral-light-gray border-neutral-gray border-t">
                      <CustomLink
                        className="block p-4 font-semibold transition-colors duration-300 text-p hover:text-neutral-black"
                        href={`${discoveryUrl}${t('paths.harmony')}`}
                        onClick={handleNavigationLinkClick}
                      >
                        {t('titles.harmony-w-natural-eye')}
                      </CustomLink>
                    </li>
                  </ul>
                </div>
              </li>
            )}

          {!shouldHideAuNavItems && t('paths.procedure') && (
            <li className="c-the-header__nav-item hidden pis-8 xl:block">
              <CustomLink
                className={classNames(
                  'font-bold text-center uppercase transition-all duration-300 text-button align-middle text-neutral-white hover:text-neutral-light-gray',
                  {
                    'text-neutral-white hover:text-neutral-light-gray':
                      (isClear && !isClearDark) ||
                      (!isClear && theme === 'dark'),
                    'text-neutral-white hover:text-neutral-light-gray md:text-neutral-dark-gray md:hover:text-neutral-black':
                      isClear && isClearDark,
                    'text-neutral-dark-gray hover:text-neutral-black':
                      !isClear && theme === 'light',
                  }
                )}
                href={`${discoveryUrl}${t('paths.procedure')}`}
                onClick={handleNavigationLinkClick}
              >
                <span>{t('titles.procedure')}</span>
              </CustomLink>
            </li>
          )}

          {!shouldHideAuNavItems && t('paths.why-visian') && (
            <li className="c-the-header__nav-item hidden pis-8 xl:block">
              <CustomLink
                className={classNames(
                  'font-bold text-center uppercase transition-all duration-300 text-button align-middle text-neutral-white hover:text-neutral-light-gray',
                  {
                    'text-neutral-white hover:text-neutral-light-gray':
                      (isClear && !isClearDark) ||
                      (!isClear && theme === 'dark'),
                    'text-neutral-white hover:text-neutral-light-gray md:text-neutral-dark-gray md:hover:text-neutral-black':
                      isClear && isClearDark,
                    'text-neutral-dark-gray hover:text-neutral-black':
                      !isClear && theme === 'light',
                  }
                )}
                href={`${discoveryUrl}${t('paths.why-visian')}`}
                onClick={handleNavigationLinkClick}
              >
                <span>{t('titles.why-visian')}</span>
              </CustomLink>
            </li>
          )}

          {!shouldHideAuNavItems &&
            t('paths.life-with-visian') &&
            !siteInfo.isNL &&
            !siteInfo.isIN &&
            !siteInfo.isJP &&
            !siteInfo.isAU && (
              <li className="c-the-header__nav-item hidden pis-8 xl:block">
                <CustomLink
                  className={classNames(
                    'font-bold text-center uppercase transition-all duration-300 text-button align-middle text-neutral-white hover:text-neutral-light-gray',
                    {
                      'text-neutral-white hover:text-neutral-light-gray':
                        (isClear && !isClearDark) ||
                        (!isClear && theme === 'dark'),
                      'text-neutral-white hover:text-neutral-light-gray md:text-neutral-dark-gray md:hover:text-neutral-black':
                        isClear && isClearDark,
                      'text-neutral-dark-gray hover:text-neutral-black':
                        !isClear && theme === 'light',
                    }
                  )}
                  href={`${discoveryUrl}${t('paths.life-with-visian')}`}
                  onClick={handleNavigationLinkClick}
                >
                  <span>{t('titles.life-with-visian')}</span>
                </CustomLink>
              </li>
            )}
          {t('paths.faq') && !siteInfo.isIN && !siteInfo.isAU && (
            <li className="c-the-header__nav-item hidden pis-8 xl:block">
              <CustomLink
                className={classNames(
                  'font-bold text-center uppercase transition-all duration-300 text-button align-middle text-neutral-white hover:text-neutral-light-gray',
                  {
                    'text-neutral-white hover:text-neutral-light-gray':
                      (isClear && !isClearDark) ||
                      (!isClear && theme === 'dark'),
                    'text-neutral-white hover:text-neutral-light-gray md:text-neutral-dark-gray md:hover:text-neutral-black':
                      isClear && isClearDark,
                    'text-neutral-dark-gray hover:text-neutral-black':
                      !isClear && theme === 'light',
                  }
                )}
                href={`${discoveryUrl}${t('paths.faq')}`}
                onClick={handleNavigationLinkClick}
              >
                <span>{t('titles.faq')}</span>
              </CustomLink>
            </li>
          )}
          {!siteInfo.isUS &&
            !siteInfo.isCA &&
            !siteInfo.isGE &&
            !siteInfo.isUK &&
            !siteInfo.isAU &&
            quizUrl && (
            <li className="hidden pis-8 xl:block">
              <AButton
                type="a"
                href={quizUrl}
                target={quizUrl !== '/' ? '_blank' : '_self'}
                rel="noreferrer"
                style="outline"
                color={isClear || theme === 'dark' ? 'white' : 'gray'}
                onClick={handleQuizButtonClick}
              >
                <span>{t('titles.take-our-quiz')}</span>
              </AButton>
            </li>
          )}
        </>
      )}

      {doctorsUrl && (
        <li className={`${!siteInfo.isUS ? 'hidden' : ''} md:pis-8 md:block`}>
          <AButton
            type="a"
            href={doctorsUrl}
            target={doctorsUrl !== '/' ? '_blank' : '_self'}
            rel="noreferrer"
            style={'solid'}
            color={'teal'}
            icon={SvgSearchIcon}
            iconClass="stroke-current w-6 h-6"
            onClick={handleDoctorsButtonClick}
            className={
              'text-[12px] md:text-[13px] rounded-[21px] !py-[0] md:!py-[6px] !px-[14px] md:!px-[22px] md:!rounded-[20px] text-[#30B2C0] md:text-neutral-white bg-[#E9F6F7] md:bg-primary-teal border-[2px] border-teal md:!border-none h-[40px] md:h-auto'
            }
          >
            <span>{t('titles.find-a-doctor')}</span>
          </AButton>
        </li>
      )}

      <li className={shouldHideAuNavItems ? 'mis-auto md:mis-6 xl:hidden' : 'mis-2 md:mis-6 xl:hidden'}>
        <button
          className={classNames(
            'rounded-full p-[6px] inline-flex items-center justify-center uppercase transition-all duration-300 align-middle border-2',
            {
              'border-neutral-white text-neutral-white hover:bg-neutral-white hover:text-neutral-dark-gray':
                (isClear && !isClearDark) || (!isClear && theme === 'dark'),
              'border-neutral-white text-neutral-white hover:bg-neutral-white hover:text-neutral-dark-gray md:border-neutral-dark-gray md:text-neutral-dark-gray md:hover:bg-neutral-dark-gray md:hover:text-neutral-white':
                isClear && isClearDark,
              'border-primary-teal text-primary-teal hover:bg-primary-teal hover:text-neutral-white':
                !isClear && theme === 'light',
            }
          )}
          onClick={openMenu}
        >
          <ASvg
            className="fill-current w-6 h-6"
            svg={SvgHamburgerIcon}
            aria-label={t('hamburger')}
          />
        </button>
      </li>
    </ul>
  )
}
